import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Sidebar from './Sidebar';
import Navbar from './Navbar';

const DashboardLayout = ({ children, user, logout }) => {
  const [collapsed, setCollapsed] = useState(false);

  const styles = `
    .dashboard-layout {
      min-height: 100vh;
      height: 100vh;
      background: hsl(var(--background));
      display: flex;
      overflow: hidden;
      position: fixed;
      width: 100%;
    }

    .dashboard-main {
      flex: 1;
      margin-left: ${collapsed ? 'var(--sidebar-collapsed)' : 'var(--sidebar-width)'};
      margin-top: var(--header-height);
      padding: var(--page-padding);
      transition: margin-left 0.3s cubic-bezier(0.22, 1, 0.36, 1);
      overflow-y: auto;
      overflow-x: hidden;
      height: calc(100vh - var(--header-height));
    }

    @media (max-width: 768px) {
      .dashboard-main {
        margin-left: 0;
      }
    }
  `;

  return (
    <>
      <style>{styles}</style>
      <div className="dashboard-layout">
        <Sidebar user={user} logout={logout} collapsed={collapsed} setCollapsed={setCollapsed} />
        <Navbar user={user} collapsed={collapsed} />

        <motion.div
          className="dashboard-main"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          {children}
        </motion.div>
      </div>
    </>
  );
};

export default DashboardLayout;
